var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('header-my-channels',{attrs:{"viewAdd":_vm.viewAdd}}),_c('list-my-channels',{attrs:{"viewAdd":_vm.viewAdd,"existing-payment-info":_vm.existingPaymentInfo},on:{"viewAddTrue":function($event){_vm.viewAdd = true}}}),_c('form-my-channels')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }